module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('polidog', {
    attrs: {
      "flagState": _vm.flagState
    }
  }), _vm._v(" "), _c('buttons', {
    attrs: {
      "flagState": _vm.flagState,
      "isStarted": _vm.isStarted,
      "count": _vm.count
    },
    on: {
      "updateData": _vm.updateData
    }
  }), _vm._v(" "), _c('messages', {
    attrs: {
      "time": _vm.time,
      "question": _vm.question,
      "message": _vm.message
    }
  }), _vm._v(" "), _c('start-button', {
    attrs: {
      "isStarted": _vm.isStarted
    },
    on: {
      "startGame": _vm.startGame
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19f1eb28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 24
// module chunks = 0